(() => {
  if (customElements.get('dc-artwork')) return;
  const images = {"Cross":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set01-olive-cross-dirty-south-thumbnail_800x800.jpg?v=1792474426","CHASIN BIRDIES":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set02-chasin-birdies-dirty-south-thumbnail_800x800.jpg?v=1792474498","American Flag":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set03-distressed-american-flag-dirty-south-thumbnail_800x800.jpg?v=1792474529","THUNDER CHICKEN":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set04-thunder-chicken-dirty-south-thumbnail_800x800.jpg?v=1792474556","STACKIN RACKS":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set06-stackin-racks-dirty-south-thumbnail_800x800.jpg?v=1792474606","THROW THE LEAD":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set07-throw-the-lead-dirty-south-thumbnail_800x800.jpg?v=1792474649","CHASIN TAIL":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set09-chasin-tail-dirty-south-thumbnail_800x800.jpg?v=1792474706","DUCK HUNT":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/01-thumbnail_5b533b81-1709-4e63-8674-e477ded9fbc2_800x800.jpg?v=1792535713","HUNT":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/01-thumbnail_1ae80f8d-67f5-4ec0-982c-712b6a9d69a1_800x800.jpg?v=1792535800","Alabama":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-alabama-brown-batch2_800x800.png?v=1791244391","Florida":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-florida-pebbled_30bab6c3-e197-4004-9460-97a4374291d9_800x800.png?v=1791243884","Georgia":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-georgia-pebbled_b612d8cc-bbf9-4e29-a613-2e749e130698_800x800.png?v=1791243884","Louisiana":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-louisiana-brown-batch2_800x800.png?v=1791244391","Mississippi":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/set08-tan-mississippi-dirty-south-thumbnail_800x800.jpg?v=1792474678","North Carolina":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-north-carolina-brown-batch2_800x800.png?v=1791244391","South Carolina":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-south-carolina-brown-batch2_800x800.png?v=1791244391","Tennessee":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-tennessee-brown-batch2_800x800.png?v=1791244391","Texas":"https://cdn.shopify.com/s/files/1/1009/3271/4798/files/dirty-texas-brown-batch2_800x800.png?v=1791244391"};
  const state = new Map();
  class DCArtwork extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.section = this.closest('.shopify-section');
      this.form = this.closest('form');
      const saved = state.get(this.dataset.productId);
      if (saved) {
        this.querySelector('[data-artwork-notes]').value = saved.notes;
        this.querySelector('[data-artwork-ack]').checked = saved.ack;
        this.querySelector('[data-artwork-mode="' + saved.mode + '"]').checked = true;
        if (saved.file) {
          const transfer = new DataTransfer();
          transfer.items.add(saved.file);
          this.querySelector('[data-artwork-file]').files = transfer.files;
        }
      }
      this.addEventListener('input', () => this.remember(), {signal});
      this.addEventListener('change', () => {this.refresh(); this.remember();}, {signal});
      this.section?.addEventListener('change', () => this.refreshPreview(), {signal});
      this.form?.addEventListener('submit', event => {
        this.validate();
        if (!this.form.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.form.reportValidity();
        }
      }, {capture: true, signal});
      this.refresh();
    }
    disconnectedCallback() {this.controller?.abort();}
    remember() {
      state.set(this.dataset.productId, {
        notes: this.querySelector('[data-artwork-notes]').value,
        mode: this.querySelector('[data-artwork-mode]:checked').dataset.artworkMode,
        ack: this.querySelector('[data-artwork-ack]').checked,
        file: this.querySelector('[data-artwork-file]').files[0]
      });
    }
    refresh() {
      const upload = this.querySelector('[data-artwork-mode]:checked').dataset.artworkMode === 'upload';
      const file = this.querySelector('[data-artwork-file]');
      const ack = this.querySelector('[data-artwork-ack]');
      this.querySelector('[data-upload-panel]').hidden = !upload;
      file.disabled = !upload;
      file.required = upload;
      ack.disabled = !upload;
      ack.required = upload;
      this.validate();
      this.refreshPreview();
    }
    validate() {
      const file = this.querySelector('[data-artwork-file]');
      const selected = file.files[0];
      const valid = !selected || (/\.(png|jpe?g|pdf)$/i.test(selected.name) && selected.size <= 10 * 1024 * 1024 && selected.size > 0);
      file.setCustomValidity(valid ? '' : this.dataset.fileError);
      this.querySelector('[data-artwork-error]').textContent = valid ? '' : this.dataset.fileError;
    }
    refreshPreview() {
      const fields = [...(this.section?.querySelectorAll('fieldset') || [])];
      const design = fields.find(f => /patch design/i.test(f.querySelector('legend')?.textContent || ''));
      const chosen = design?.querySelector('input:checked')?.value || '';
      const image = this.querySelector('[data-design-image]');
      const caption = this.querySelector('[data-design-caption]');
      const upload = this.querySelector('[data-artwork-mode]:checked').dataset.artworkMode === 'upload';
      image.hidden = upload || !images[chosen];
      if (!image.hidden) {image.src = images[chosen];image.alt = chosen + ' — ' + this.dataset.previewLabel;}
      caption.textContent = upload ? this.querySelector('[data-upload-panel] label').textContent : chosen + ' — ' + (images[chosen] ? this.dataset.previewLabel : this.dataset.missingLabel);
    }
  }
  customElements.define('dc-artwork', DCArtwork);
})();